import {
  actionCreator,
  checkHttpStatus,
  DELETE_MASTERCLINICALROOM,
  masterClinicalRoomActionTypes,
  GET_MASTERCLINICALROOM,
  GET_MASTERCLINICALROOM_BY_ID,
  jsonApiHeader,
  POST_MASTERCLINICALROOM,
  showErrorMessage,
  showSuccessMessage,
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI, showWarningMessage } from '../../../../../actions/utilAction';

export const getMasterClinicalRoomList = (searchObj) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(masterClinicalRoomActionTypes.get_master_clinicalroom.REQUEST));

    let query_params = createSearchUrlForCustomAPI(searchObj);;
    fetch(`${GET_MASTERCLINICALROOM}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
    .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
        dispatch(actionCreator(masterClinicalRoomActionTypes.get_master_clinicalroom.SUCCESS, response));
        } else {
          dispatch(actionCreator(masterClinicalRoomActionTypes.get_master_clinicalroom.SUCCESS, null));
        }
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const saveMasterClinicalRoom = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(masterClinicalRoomActionTypes.post_master_clinicalroom.REQUEST));
    fetch(`${POST_MASTERCLINICALROOM}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(masterClinicalRoomActionTypes.post_master_clinicalroom.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(masterClinicalRoomActionTypes.post_master_clinicalroom.SUCCESS, null));
        }
      });
  };
};

export const deleteMasterClinicalRoom = (id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(masterClinicalRoomActionTypes.delete_master_clinicalroom.REQUEST));

    fetch(`${DELETE_MASTERCLINICALROOM}?roomId=${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(masterClinicalRoomActionTypes.delete_master_clinicalroom.SUCCESS, response));
          let searchObj = {
            sort_fields: 'id',
            sort_order:  'desc',
            contain_filters: { SearchText: null },
            pageNumber: 1,
          };
          dispatch(getMasterClinicalRoomList(searchObj));
        } else if (response.statusCode === 401) {
          showWarningMessage(response.message);
          dispatch(actionCreator(masterClinicalRoomActionTypes.delete_master_clinicalroom.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(masterClinicalRoomActionTypes.delete_master_clinicalroom.SUCCESS, null));
        }
      }).catch(function(error) {
        // console.log(error);
      });
  };
};
export const getMasterClinicalRoomById = (Id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(masterClinicalRoomActionTypes.get_master_clinicalroom_by_id.REQUEST));

    fetch(`${GET_MASTERCLINICALROOM_BY_ID}?roomId=${Id}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
        dispatch(actionCreator(masterClinicalRoomActionTypes.get_master_clinicalroom_by_id.SUCCESS, response));
        } else {
          dispatch(actionCreator(masterClinicalRoomActionTypes.get_master_clinicalroom_by_id.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};




// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterClinicalRoom/actions/MasterClinicalRoomActions.js